import React from 'react';
import { AtlassianIcon } from '../../icons/AtlassianIcon';
import { MicrosoftIcon } from '../../icons/MicrosoftIcon';
import { solutionsIntegrations } from '../../../shared/config/solutionsContent';

const CARD_ICONS = {
  atlassian: AtlassianIcon,
  microsoft: MicrosoftIcon,
} as const;

/**
 * Delivery-stack strip under the hero. Copy lives in solutionsContent so the
 * SPA and prerendered twin cannot drift.
 */
export function SolutionsIntegrationsStrip(): React.ReactElement {
  return (
    <section
      className="solutions-integrations solutions-integrations--quiet"
      aria-label="Connects with your delivery stack"
    >
      <p className="solutions-integrations__eyebrow">{solutionsIntegrations.eyebrow}</p>
      <div className="solutions-integrations__grid">
        {solutionsIntegrations.cards.map((card) => {
          const Icon = CARD_ICONS[card.id];
          return (
            <article key={card.id} className="solutions-integration-card">
              <div className="solutions-integration-card__icon" aria-hidden="true">
                <Icon size={34} className="solutions-integration-card__glyph" />
              </div>
              <div className="solutions-integration-card__body">
                <h3 className="solutions-integration-card__title">{card.title}</h3>
                <p
                  className={`solutions-integration-card__badge solutions-integration-card__badge--${card.badgeKind}`}
                >
                  {card.badge}
                </p>
                <p className="solutions-integration-card__subtitle">{card.subtitle}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
